module.exports = __webpack_public_path__ + "img/fb.13697b20.svg";